import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { companiesFilterForGrid, searchTermSelector, currentOrganizationId } from '@/domain/companies';

import { isDokkaSupportSelector } from '@/domain/env';

import Api from '@/domain/api';

const useFetchGridData = () => {
  const dispatch = useDispatch();

  const searchTerm = useSelector(searchTermSelector);
  const isDokkaSupport = useSelector(isDokkaSupportSelector);
  // present for ghost only, null otherwise
  const orgId = useSelector(currentOrganizationId);

  const [columnDefs, setColumnDefs] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [isBusy, setIsBusy] = useState(true);

  const fetchGridColumnHeaders = useCallback(async () => Api.getCompaniesGrid({ params: { org_id: orgId } }), []);

  useEffect(() => {
    setIsBusy(true);

    fetchGridColumnHeaders()
      .then(({ data }) => {
        setColumnDefs(data.headers);
        setRowData(data.items);
      })
      .catch(() => {
        // TODO: ag-grid doLogout Action
      })
      .finally(() => {
        setIsBusy(false);
      });
  }, [fetchGridColumnHeaders, dispatch]);

  const filteredData = useMemo(() => {
    return companiesFilterForGrid(rowData, searchTerm, isDokkaSupport);
  }, [rowData, searchTerm, isDokkaSupport]);

  return {
    rawColumnDefs: columnDefs,
    rowData: filteredData,
    rawRowData: rowData,
    rawDataIsBusy: isBusy,
    setRawColumnDefs: setColumnDefs,
    setRawRowData: setRowData,
  };
};

export default useFetchGridData;
